module.exports = __webpack_public_path__ + "img/81.fac62151.jpg";